<template>
  <v-card v-if="display" :disabled="lockSettings" class="toggle-dest">
    <v-card-title class="dest-title">
      <v-icon color="red" v-show="lockSettings">mdi-lock</v-icon>
      {{ $t('settings.toggle.title')}}&nbsp;
      <cp-help i18n="toggle"/>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :loading="loading"
        :headers="headers"
        hide-default-header
        hide-default-footer
        :items="dests">

        <template v-slot:item.name="{ item }">
          {{ item.name }}
        </template>

        <template v-slot:item.id="{ item }">
          ID: {{ item.id }}
        </template>

        <template v-slot:item.optA="{ item }">
          <v-btn small icon @click="toggle(item)" :disabled="btnDisabled"
            :color="iconColor(item.isActiveA)" elevation="1">
            <v-icon>mdi-{{ item.isActiveA | optIcon }}</v-icon>
          </v-btn>

          <span :class="activeClass(item.isActiveA)">
            {{ item.optAType }} {{ item.optATarget }}
          </span>
        </template>

        <template v-slot:item.optB="{ item }">
          <v-btn small icon @click="toggle(item)" :disabled="btnDisabled"
            :color="iconColor(item.isActiveB)" elevation="1">
            <v-icon>mdi-{{ item.isActiveB | optIcon }}</v-icon>
          </v-btn>

          <span :class="activeClass(item.isActiveB)">
            {{ item.optBType }} {{ item.optBTarget }}
          </span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import API from '@/api'
import events from 'Store/events'

export default {
  name: 'settings-toggle-destinations',
  data () {
    return {
      loading: false,
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'ID', value: 'id' },
        { text: 'Option A', value: 'optA' },
        { text: 'Option B', value: 'optB' }
      ]
    }
  },

  filters: {
    optIcon: function (active) {
      return active
        ? 'checkbox-marked-circle-outline'
        : 'checkbox-blank-circle-outline'
    }
  },

  computed: {
    ...mapGetters({
      canRead: 'permissions/toggleRead',
      canWrite: 'permissions/toggleWrite',
      destsTotal: 'settings/toggle/total',
      isOwnerCurUser: 'settings/isOwnerCurUser',
      dests: 'settings/toggle/destinations'
    }),

    display: function () {
      // display component if permission allows
      // and at least one toggle destination to list
      return this.canRead && this.destsTotal > 0
    },

    btnDisabled: function () {
      return !this.canWrite || this.loading
    },

    lockSettings: function () {
      return !this.isOwnerCurUser
    }
  },

  methods: {
    ...mapActions({ toggleDest: 'settings/toggle/doToggle' }),
    activeClass: function (active) {
      if (active) {
        return ['font-weight-medium']
      }
      return []
    },

    iconColor: function (active) {
      return active
        ? 'green'
        : 'red'
    },

    toggle: function (item) {
      const dest = item.isActiveA ? item.optB : item.optA
      this.loading = true
      API.switchToggleDest(item.id, dest).then(() => {
        this.toggleDest(item.id)
        events.pubNotify({
          text: 'settings.toggle.notifySuccess',
          args: { name: item.name, dest: item.activeOptName },
          status: 'success'
        })
      }).catch(err => {
        events.pubError(API.getException(err) || 'Failed to update toggle destination')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
</style>
